export default __webpack_public_path__ + "static/media/Brow_5_C3.6492af4c.svg";